import { connectCustom } from "@client/lib/misc";

import { type RootContainerProps } from "@client/content/types";
import { combinedSettingsSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import Component, { type InstagramComponentProps } from "./component";
import { makeFeedOptionsSelector, makeItemStyleSelector } from "./selectors";

const makeMapStateToProps = () => {
  const feedOptionsSelector = makeFeedOptionsSelector();
  const itemStyleSelector = makeItemStyleSelector();
  const itemsGapSelector = getSettingValueSelector(TargetSelector.Entity, "itemsGap");

  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, [
    { name: "itemsInRow", prop: "columns" },
    { name: "width", prop: "columnWidth", path: "thumb" }
  ]);
  return (state: AppState, props: RootContainerProps): InstagramComponentProps => {
    const settings = settingsSelector(state, props);

    return {
      feedOptions: feedOptionsSelector(state, props),
      itemGap: itemsGapSelector(state, props),
      itemStyle: itemStyleSelector(state, props),
      ...settings,
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
